"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateQueryTypes = void 0;
exports.StateQueryTypes = {
    state: 'state',
    district: 'district',
};
